import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { PortalRole } from '@/auth/roleAccess';

interface RequireRoleProps {
  roles: readonly PortalRole[];
  children?: ReactNode;
  fallback?: ReactNode;
}

export default function RequireRole({ roles, children, fallback }: RequireRoleProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user?.role || !roles.includes(user.role)) {
    return fallback ?? <Navigate to="/" replace />;
  }

  return children ?? <Outlet />;
}
